import axios from "axios";
import { GetApiResponse } from "../types/api";
import { DroughtEvents } from "../types/droughtEvents";
import { apiV1BaseUrl } from "./index";

export const getDroughtEventsTimeseriesService = async ({
  country,
}: {
  country: string;
}) => {
  try {
    const response = await axios.get<GetApiResponse<DroughtEvents>>(
      `${apiV1BaseUrl}/timeseries/DroughtEvents`,
      {
        params: { country },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
